import { isFlatAtIncrement, numberSignVariant } from '../core';
import { FUNDING_RATE_DISPLAY_INCREMENT } from './tokens';

/** Green for a positive rate, red for negative, neutral at zero — shared by the List and Matrix cells. */
export const rateSignVariant = numberSignVariant;

/**
 * True when the rate displays as 0.0000% at the shown precision — i.e. no visible change. Shared by
 * the List and Matrix cells (and their hover tooltips) so a rate that displays as zero never gets
 * sign-colored anywhere.
 */
export function isFlatRate(value: number): boolean {
  return isFlatAtIncrement(value, FUNDING_RATE_DISPLAY_INCREMENT);
}
